// Phase-A R5 — Co-brand footer for the redesigned login.
// پژوهشگاه نیرو mark + center text + nav links. Theme-aware logo swap via two
// <img> tags that toggle on html[data-theme] (same pattern as OrgAttribution).
import React from "react";

const FootLink: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <a
    href="#"
    onClick={(e) => e.preventDefault()}
    style={{
      color: "var(--r5-muted)",
      textDecoration: "none",
      transition: "color 160ms ease",
    }}
    onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = "var(--r5-ink)"; }}
    onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = "var(--r5-muted)"; }}
  >
    {children}
  </a>
);

const NriMark: React.FC = () => (
  <>
    {/* S-LP-6 — 192px WebP (~9KB; renders at 40px). Both theme slots are
        always in the DOM; loading="lazy" lets the browser skip the
        display:none one. PNG original stays on disk. */}
    <img
      src="/tenants/nri/pajooheshgah-192.webp"
      alt="نشان پژوهشگاه نیرو"
      width="40"
      height="40"
      loading="lazy"
      decoding="async"
      className="r5-brand-mark is-light"
      style={{ width: 40, height: "auto", objectFit: "contain" }}
    />
    <img
      src="/tenants/nri/pajooheshgah-192.webp"
      alt=""
      aria-hidden="true"
      width="40"
      height="40"
      loading="lazy"
      decoding="async"
      className="r5-brand-mark is-dark"
      style={{ width: 40, height: "auto", objectFit: "contain" }}
    />
  </>
);

export const CoBrandFooter: React.FC = () => (
  <footer
    style={{
      marginTop: "clamp(28px, 5vh, 56px)",
      paddingTop: 20,
      borderTop: "1px solid var(--r5-line)",
      display: "flex",
      flexWrap: "wrap",
      gap: 18,
      alignItems: "center",
      justifyContent: "space-between",
      fontSize: 11.5,
      color: "var(--r5-muted)",
    }}
  >
    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
      <NriMark />
      <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.35 }}>
        <span style={{ fontWeight: 600, color: "var(--r5-ink-2)", fontSize: 12 }}>
          زیر نظر پژوهشگاه نیرو
        </span>
        <span style={{ fontFamily: "var(--r5-mono)", fontSize: 10, letterSpacing: "0.06em" }}>
          سامانهٔ آموزش ضمن خدمت صنعت آب و برق
        </span>
      </div>
    </div>
    <nav style={{ display: "flex", gap: 18, flexWrap: "wrap" }}>
      <FootLink>قوانین و حریم خصوصی</FootLink>
      <FootLink>پشتیبانی</FootLink>
      <FootLink>وضعیت سامانه</FootLink>
      <FootLink>API</FootLink>
    </nav>
  </footer>
);

export default CoBrandFooter;
